import React, { useState } from 'react';
import './EchangesList.css';
import CommentaireForm from '../CommentaireForm/CommentaireForm';

interface Echange {
  date: string;
  heure: string;
  auteur: string;
  message: string;
  type: 'user' | 'platform' | 'other';
}

interface EchangesListProps {
  titre: string;
  echanges: Echange[];
  currentUser: string; // Ajout de l'utilisateur actuel
  showCommentaireForm?: boolean; // Avoir le boite a message

}

const EchangesList: React.FC<EchangesListProps> = ({ titre, echanges: initialEchanges, currentUser, showCommentaireForm = true }) => {
  const [echanges, setEchanges] = useState<Echange[]>(initialEchanges);

  const handleNewComment = (message: string) => {
    const now = new Date();
    const newEchange: Echange = {
      date: now.toLocaleDateString('fr-FR'),
      heure: now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }),
      auteur: currentUser,
      message: message,
      type: 'user'
    };

    setEchanges([...echanges, newEchange]);
  };

  const getMessageClass = (type: 'user' | 'platform' | 'other') => {
    switch (type) {
      case 'user':
        return 'message-user';
      case 'platform':
        return 'message-platform';
      default:
        return 'message-other';
    }
  };

  return (
    <div className="echanges-list">
      {/* <h2 className="echanges-title">{titre}</h2> */}
      {/* <hr className="darkblue"/> */}
      <div className="echanges-container">
        {echanges.map((echange, index) => (
          <div key={index} className="echange-wrapper">
            <div className={`message-bubble ${getMessageClass(echange.type)}`}>
              <p className="echange-message">{echange.message}</p>
            </div>
            <div className="echange-footer">
              <span className="echange-auteur">{echange.auteur}, </span>
              <span className="echange-date">
                {echange.date} à {echange.heure}
              </span>
            </div>
          </div>
        ))}
      </div>

      {showCommentaireForm && (
        <CommentaireForm onSubmit={handleNewComment} />
      )}
    </div>
  );
};

export default EchangesList;